import { FunctionComponent, useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ConfigContext, UserContext } from '../../context';
import {
  Avatar,
  getChannelDomain,
  getWebAppUrl,
  IconLabel,
  layoutPath,
  ModalSlidePanel,
  PanelSide,
  useIsNarrowViewport,
} from '../../shared';
import { SidebarOrganisation } from '../SidebarOrganisation';

import classNames from 'classnames';
import classes from './NavbarOrganisation.module.scss';

export const NavbarOrganisation: FunctionComponent = () => {
  const { t } = useTranslation();

  const isNarrowViewport = useIsNarrowViewport();

  const { avatar } = useContext(UserContext).userProfile;

  const {
    organisationLogoUrl,
    meta: { title },
    mobile: { menuIconColor },
  } = useContext(ConfigContext).config.elements;

  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);

  const mobilePanelClose = useCallback(() => {
    setMobilePanelOpen(false);
  }, []);

  return (
    <>
      <header className={classes['navbar']}>
        <div
          className={classNames(classes['navbar__container'], {
            [classes['navbar__container--narrow']]: isNarrowViewport,
          })}
        >
          {isNarrowViewport && (
            <>
              <IconLabel
                iconId={'mobile-menu'}
                ariaLabel={t('common.menu')}
                onClick={() => setMobilePanelOpen(!mobilePanelOpen)}
                color={menuIconColor}
                singleColor
              />
              <ModalSlidePanel
                isOpen={mobilePanelOpen}
                body={<SidebarOrganisation />}
                side={PanelSide.left}
                onClose={mobilePanelClose}
                ariaLabel={t('common.menu')}
              />
            </>
          )}

          <div className={classes['navbar__logo-wrapper']}>
            <Link className={classes['navbar__logo']} to={layoutPath('/')}>
              <img
                src={organisationLogoUrl}
                className={classNames(classes['navbar__logo-icon'], {
                  [classes['navbar__logo-icon--narrow']]: isNarrowViewport,
                })}
                alt={title}
              />
            </Link>
          </div>

          <Avatar
            url={avatar?.url}
            ariaLabel={t('profile.open-profile')}
            onClick={() =>
              window.open(
                `${getWebAppUrl(getChannelDomain())}/admin/profile`,
                '_blank',
                'noopener, noreferrer'
              )
            }
          />
        </div>
      </header>
    </>
  );
};
